@if(pregunta) {

  <div class="col-12 mb-3">
    <p>
      <b>{{ pregunta.pregunta }}</b>
    </p>
  </div>
  <!-- {{ pregunta.tipoPregunta?.nombre }}
  {{ pregunta.tipoPregunta?.descripcion }} -->

  @if(pregunta.tipoPregunta?.nombre == 'Escala numérica') {
    <div class="col-12">
      <app-scale
        [pregunta]="pregunta"
        [(scaleValue)]="pregunta.rango">
      </app-scale>
    </div>
  } 

  @if(pregunta.tipoPregunta?.nombre == 'Selección simple') {
    <!-- <div>
      <input class="form-check-input" type="radio" name="radioNoLabel" id="radioNoLabel1" value="" aria-label="...">
    </div> -->
    <div class="col-12">
      <app-single-selection
        [options]="pregunta.opciones"
        [(selected)]="pregunta.respuesta">
      </app-single-selection>
    </div>
  }

  @if(pregunta.tipoPregunta?.nombre == 'Selección múltiple') {
    <div class="col-12">
      <app-multiple-option
        [options]="pregunta.opciones"
        [(selected)]="pregunta.respuestas">
      </app-multiple-option>
    </div>
  }

  @if(pregunta.tipoPregunta?.nombre == 'Abierta') {
    <div class="col-12">
      <textarea 
        class="form-control" 
        rows="3"
        [(ngModel)]="respuestaTexto"
        (ngModelChange)="onRespuestaTextoChange($event)"
        [maxlength]="answerMaxLength"
        placeholder="Escriba su respuesta aquí..."></textarea>
    </div>
  }

}